import { vservice } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vservice()
export class PanelWalletRoute extends RouteBase {
  prefix = 'panel.wallet.'

  index() {
    return this.ziggyRoute('index')
  }

  paymentLink() {
    return this.ziggyRoute('payment_link')
  }
}
